export enum BackgroundType {
  CountdownBackground,
  MiscBackground,
  RegisterBackground
}
